import { Component, OnInit, Injector } from '@angular/core';
import { ZimbraInstanceService } from 'src/app/_service/zimbrainstance.service';
import { AdminOnlyPageComponent }     from '../../_components/AdminOnlyPageComponent';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css']
})
export class AdminDashboardComponent extends AdminOnlyPageComponent implements OnInit {

  constructor(  
    private injector              : Injector,
    private _zimbraInstanceService : ZimbraInstanceService
  ) 
  { 
    super(injector);
  }

  ngOnInit() 
  {
  }


  zimbraLogin()
  {
    this._zimbraInstanceService.zimbraLogin().subscribe(
      data => {
          window.open(data["retdata"]["data"], "_blank");
          // console.log(data);
      },
      err => {
        this._interfaceService.openSimpleErrorSnackBar(this._translateService.instant("errors.something_went_wrong"));
    })
  }

}
